import { http } from "services/http";

import type {
  NewsIdRequest,
  NewsIdResponse,
  NewsListResponse,
  NewsNotifyRequest,
  NewsPost,
  NewsSendUserDataResponse,
  NewsTag,
  NewsTagCreateRequest,
  NewsTagUpdateRequest,
} from "models/news.model";

const multipart = { headers: { contentType: "multipart/form-data" } };

export const newsApi = {
  // NewsPost[...], NewsPostField[...] and NewsTag[] appended to a FormData, with the
  // images as files.
  saveNews: (data: FormData) => http.quiet().post<NewsIdResponse>("/api/news/add", data, multipart),
  updateNews: (data: FormData) =>
    http.quiet().post<NewsIdResponse>("/api/news/update", data, multipart),
  getNews: () => http.quiet().get<NewsListResponse>("/api/news"),
  getPost: (data: NewsIdRequest) => http.quiet().post<NewsPost>("/api/news/show", { ...data }),
  getTags: () => http.quiet().get<NewsTag[]>("/api/news/tags"),
  createTag: (data: NewsTagCreateRequest) =>
    http.quiet().post("/api/news/tags/create", { ...data }),
  updateTag: (data: NewsTagUpdateRequest) =>
    http.quiet().post("/api/news/tags/update", { ...data }),
  deleteTag: (data: NewsIdRequest) => http.quiet().post("/api/news/tags/delete", { ...data }),
  deletePost: (data: NewsIdRequest) => http.quiet().post("/api/news/delete", { ...data }),
  sendMail: (data: NewsNotifyRequest) => http.quiet().post("/api/news/notify-users", { ...data }),
  sendTemplateToMailtrap: (data: NewsIdRequest) =>
    http.quiet().post("/api/news/send-template", { ...data }),
  sendUserData: () =>
    http.quiet().post<NewsSendUserDataResponse>("/api/news/send-user-data", {}),
};
